import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import * as DevModules from 'devextreme-angular';

import { GridComponent } from './grid.component';
import { GridColumnComponent } from './grid-column/grid-column.component';
import { ModeloGridModule } from '../modelo-grid/modelo-grid.module';

@NgModule({
   imports: [
      CommonModule,
      DevModules.DxDataGridModule,
      ModeloGridModule
   ],
   exports: [
      GridColumnComponent,
      GridComponent
   ],
   declarations: [
      GridColumnComponent,
      GridComponent
   ]
})
export class GridModule { }
